'use strict';

var _ = require('lodash');
var PricingAnalysisPanelService = function PricingAnalysisPanelService($filter, pricingAnalysisCommonsDataService) {
  function getSnapshotDate() {
    return pricingAnalysisCommonsDataService.retrieveDepartureDatesChartData().then(function (data) {
      var eventMoment = _.chain(data).map('eventTimeStamp').sortBy(function (stamp) {
        return -1 * stamp.valueOf();
      }).first().value();
      return eventMoment;
    });
  }
  return {
    getSnapshotDate: getSnapshotDate
  };
};
PricingAnalysisPanelService.$inject = ['$filter', 'PricingAnalysisCommonsDataService'];
module.exports = PricingAnalysisPanelService;